import { render, staticRenderFns } from "./GenerateDTR.vue?vue&type=template&id=51775a09"
import script from "./GenerateDTR.vue?vue&type=script&lang=js"
export * from "./GenerateDTR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports